import { GridColDef } from "@mui/x-data-grid"
import { CustomActionsCellTypes } from "src/components/CustomActionsCell/CustomActionsCell.types";
import { CustomTemplateStatusCell } from "src/components/CustomTemplateStatusCell/CustomTemplateStatusCell";
import { ServicesSearchTypes, StudiosSearchTypes } from "src/components/ToggleBox/ToggleBox.types";

import {CustomActionsCell, CustomAddressCell, CustomAdminCell, CustomNameCell} from '../../components'

import { SortTypes } from "./StudiosScreen.types";

export const columns: GridColDef[] = [
  {
    field: 'title',
    headerName: 'Name',
    width: 275,
    sortable: false,
    renderCell: (params) => <CustomNameCell image={params.row?.images?.[1]} value={params.value} />,
  },
  {
    field: 'id',
    headerName: 'ID',
    width: 220,
    sortable: false,
  },
  {
    field: 'address',
    headerName: 'Address',
    width: 230,
    sortable: false,
    renderCell: (params) => <CustomAddressCell address={params.value} />,
  },
  {
    field: 'admins',
    headerName: 'Admins',
    width: 230,
    flex: 1,
    sortable: false,
    renderCell: (params) => <CustomAdminCell adminsArray={params.value} />,
  },
  {
    field: 'status',
    headerName: 'Status',
    width: 270,
    flex: 1,
    sortable: false,
    renderCell: (params) => <CustomTemplateStatusCell params={params}/>,
  },
  {
    field: 'actions',
    headerName: 'Actions',
    minWidth: 120,
    sortable: false,
    renderCell: (params) => <CustomActionsCell params={params} type={CustomActionsCellTypes.STUDIOS} />,
  },
];

export const paramsCatalogue = {
  sortParams: {
    [SortTypes.ID]: 'id',
    [SortTypes.NAME]: 'title',
    [SortTypes.STUDIO]: 'address',
  },
  searchParams: {
    [StudiosSearchTypes.NAME]: 'title',
    [StudiosSearchTypes.ADDRESS]: 'address',
  },
};

export const selectedStudioParamsCatalogue = {
  sortParams: {
    [SortTypes.ID]: 'id',
    [SortTypes.NAME]: 'title',
    [SortTypes.DURATION]: 'duration',
  },
  searchParams: {
    [ServicesSearchTypes.SERVICE]: 'service',
    [ServicesSearchTypes.CATEGORY]: 'category',
    [ServicesSearchTypes.SUBCATEGORY]: 'subcategory',
  },
};
